import Head from "next/head";
import { HomeLayout } from "@medbillai/app/screens/home/layout.web";
import { HomeScreen } from "@medbillai/app/screens/home/screen";
import { AuthGate } from "../utils/AuthGate";
import { withLaunchDarklyFlags } from "../utils/flag-bootstrap";
import type { NextPageWithLayout } from "./_app";
export const getServerSideProps = withLaunchDarklyFlags();
export const Page: NextPageWithLayout = () => {
  return <>
      <Head data-sentry-element="Head" data-sentry-source-file="index.tsx">
        <title>Home</title>
      </Head>
      <HomeScreen data-sentry-element="HomeScreen" data-sentry-source-file="index.tsx" />
    </>;
};
Page.getLayout = page => <AuthGate>
    <HomeLayout fullPage backgroundColor="$surface1">
      {page}
    </HomeLayout>
  </AuthGate>;
export default Page;